import type { ApolloCache } from "@apollo/client";
import { getAssetPersist } from "../asset-persist/stores/useAssetPersist";

const evictPhotos = (
	cache: ApolloCache<any>,
	photoIds: string[],
	{
		delay,
	}: {
		/**
		 * You probably want a delay to avoid things trying to refetch the deleted data
		 */
		delay?: number;
	} = {},
) => {
	const { uploadAssetsStore, updateUploadAsset, deleteUploadAsset } = getAssetPersist();
	// Maps photo IDs to upload image IDs
	const uploadAssetMapping: Record<string, string> = {};
	for (const image of Object.values(uploadAssetsStore)) {
		if (image.uploadedPhotoInfo?.photoId) {
			uploadAssetMapping[image.uploadedPhotoInfo.photoId] = image.localPhotoId;
		}
	}

	const evictedlocalPhotoIds: string[] = [];
	const handleEvict = () => {
		for (const photoId of photoIds) {
			cache.evict({
				id: cache.identify({
					__typename: "Photo",
					photoId: photoId,
				}),
			});
			const localPhotoId = uploadAssetMapping[photoId];
			if (localPhotoId) {
				evictedlocalPhotoIds.push(localPhotoId);
				updateUploadAsset({
					localPhotoId: localPhotoId,
					uploadState: "Deleted",
				});
			}
		}
		// Doing this a bit later since we want useGatheringPhotosWithLocal to have a chance to update
		if (evictedlocalPhotoIds.length > 0) {
			setTimeout(() => {
				for (const localPhotoId of evictedlocalPhotoIds) {
					deleteUploadAsset(localPhotoId);
				}
			}, 100);
		}
	};

	if (delay) {
		setTimeout(handleEvict, delay);
	} else {
		handleEvict();
	}
};
export default evictPhotos;
